import "./terms.css";
import React from "react";
import {useNavigate} from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();

  const redirectToBack = () => {
    navigate(-1);
  };

  return (
    <section id="terms" className="section">
      <div className="container">
        <div className="terms__page_wrapper">
          <div className="terms__page">
            <iframe
              src="https://pl.servicelands.com/mtk/aidente/terms-pl.html"
              title="ZASADY I WARUNKI"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{border: "none"}}
            >
              Your browser does not support iframes.
            </iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
